<script setup lang="ts">
import { ref, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const router = useRouter()
const route = useRoute()

const activeMenuItem = computed(() => {
  const path = route.path
  if (path.includes('/government/dashboard')) return 'dashboard'
  if (path.includes('/government/application-queue')) return 'application-queue'
  if (path.includes('/government/certificates')) return 'certificates'
  if (path.includes('/government/registry-oversight')) return 'registry-oversight'
  if (path.includes('/government/grievance-management')) return 'grievance-management'
  if (path.includes('/government/doe-licenses')) return 'doe-licenses'
  if (path.includes('/government/unfccc-reporting')) return 'unfccc-reporting'
  if (path.includes('/government/administration')) return 'administration'
  return 'dashboard' // default
})

const navigateTo = (route: string) => {
  router.push(route)
}
</script>

<template>
    <div id="sidebar" class="w-64 bg-white border-r border-light-gray">
        <div class="p-5 border-b border-light-gray">
            <h1 class="text-xl font-medium text-forest-green">{{ $t('government.sidebar.portal_title') }}</h1>
            <p class="text-sm text-gray-600">{{ $t('government.sidebar.portal_subtitle') }}</p>
        </div>
        
        <nav id="sidebar-nav" class="p-4">
            <div class="space-y-2">
                <span @click="navigateTo('/government/dashboard')" 
                      :class="[
                        'flex items-center p-3 rounded-md cursor-pointer',
                        activeMenuItem === 'dashboard' 
                          ? 'bg-forest-green text-white' 
                          : 'text-gray-700 hover:bg-gray-100'
                      ]">
                    <i class="fa-solid fa-chart-line w-5 h-5 mr-3"></i>
                    {{ $t('government.sidebar.dashboard') }}
                </span>
                <span @click="navigateTo('/government/application-queue')" 
                      :class="[
                        'flex items-center p-3 rounded-md cursor-pointer',
                        activeMenuItem === 'application-queue' 
                          ? 'bg-forest-green text-white' 
                          : 'text-gray-700 hover:bg-gray-100'
                      ]">
                    <i class="fa-solid fa-list-check w-5 h-5 mr-3"></i>
                    {{ $t('government.sidebar.application_queue') }}
                </span>
                <span @click="navigateTo('/government/certificates')" 
                      :class="[
                        'flex items-center p-3 rounded-md cursor-pointer',
                        activeMenuItem === 'certificates' 
                          ? 'bg-forest-green text-white' 
                          : 'text-gray-700 hover:bg-gray-100'
                      ]">
                    <i class="fa-solid fa-certificate w-5 h-5 mr-3"></i>
                    {{ $t('government.sidebar.certificates') }}
                </span>
                <span @click="navigateTo('/government/registry-oversight')" 
                      :class="[
                        'flex items-center p-3 rounded-md cursor-pointer',
                        activeMenuItem === 'registry-oversight' 
                          ? 'bg-forest-green text-white' 
                          : 'text-gray-700 hover:bg-gray-100'
                      ]">
                    <i class="fa-solid fa-database w-5 h-5 mr-3"></i>
                    {{ $t('government.sidebar.registry_oversight') }}
                </span>
                <span @click="navigateTo('/government/grievance-management')" 
                      :class="[
                        'flex items-center p-3 rounded-md cursor-pointer',
                        activeMenuItem === 'grievance-management' 
                          ? 'bg-forest-green text-white' 
                          : 'text-gray-700 hover:bg-gray-100'
                      ]">
                    <i class="fa-solid fa-exclamation-triangle w-5 h-5 mr-3"></i>
                    {{ $t('government.sidebar.grievance_management') }}
                </span>
                <span @click="navigateTo('/government/doe-licenses')" 
                      :class="[
                        'flex items-center p-3 rounded-md cursor-pointer',
                        activeMenuItem === 'doe-licenses' 
                          ? 'bg-forest-green text-white' 
                          : 'text-gray-700 hover:bg-gray-100'
                      ]">
                    <i class="fa-solid fa-file-contract w-5 h-5 mr-3"></i>
                    {{ $t('government.sidebar.doe_licenses') }}
                </span>
                <span @click="navigateTo('/government/unfccc-reporting')" 
                      :class="[
                        'flex items-center p-3 rounded-md cursor-pointer',
                        activeMenuItem === 'unfccc-reporting' 
                          ? 'bg-forest-green text-white' 
                          : 'text-gray-700 hover:bg-gray-100'
                      ]">
                    <i class="fa-solid fa-file-export w-5 h-5 mr-3"></i>
                    {{ $t('government.sidebar.unfccc_reporting') }}
                </span>
                <span @click="navigateTo('/government/administration')" 
                      :class="[
                        'flex items-center p-3 rounded-md cursor-pointer',
                        activeMenuItem === 'administration' 
                          ? 'bg-forest-green text-white' 
                          : 'text-gray-700 hover:bg-gray-100'
                      ]">
                    <i class="fa-solid fa-cog w-5 h-5 mr-3"></i>
                    {{ $t('government.sidebar.administration') }}
                </span>
            </div>
        </nav>
    </div>
</template>